import { FormEvent, useContext, useState } from 'react';

import MDEditor from '@uiw/react-md-editor';

import IconButton from '../../../../components/atoms/button/IconButton';
import Information from '../../../../components/atoms/information/Information';
import Input from '../../../../components/atoms/input';
import { TextContentData, TextContentSpecificData } from '../../../../types/contentTypes';
import AlertContext from '../../../../utils/AlertContext';
import { ContentFormProps } from '../ContentEditor';
import inputFields from '../inputFields.json';

import './TextContentForm.scss';

export default function TextContentForm({
  content,
  onNewContentSubmit,
  onExistingContentSubmit,
}: ContentFormProps<TextContentData, TextContentSpecificData>) {
  const [headline, setHeadline] = useState<string>(content?.headline || '');
  const [text, setText] = useState<string>(content?.text || '');

  const showAlert = useContext(AlertContext);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!content) {
      onNewContentSubmit?.({
        headline,
        text,
      });
    } else {
      onExistingContentSubmit?.({
        ...content,
        headline,
        text,
      });
    }
    showAlert('Changes saved!');
  }

  return (
    <div className="text-content-form form-preview">
      <div className="form-area">
        <form onSubmit={handleSubmit}>
          <div className="self-start">
            <label className="block mb-2">Enter headline</label>
            <Input className="mb-8 w-full" {...inputFields.headline} state={[headline, setHeadline]} />
          </div>
          {/* <p className="italic text-red">Title 1 is currently disabled and will not be shown, use title 2–6.</p> */}
          <Information
            text={'The text should be written using markdown syntax. It will be rendered as formatted text.'}
          >
            <MDEditor className="w-full mb-12" preview="edit" value={text} onChange={value => setText(value || '')} />
          </Information>
          <IconButton icon="save-outline" label={!content ? 'Save and add to section' : 'Save changes'} type="submit" />
        </form>
      </div>
    </div>
  );
}
